import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeftIcon, BuildingIcon, MapPinIcon, GlobeIcon, MailIcon, PhoneIcon, UserIcon, CalendarIcon, ClockIcon, ChevronDownIcon, FileTextIcon, CheckCircleIcon, AlertCircleIcon, BarChart3Icon, TrendingUpIcon, DollarSignIcon, UsersIcon, ExternalLinkIcon, ChevronRightIcon, FilterIcon, SearchIcon, BellIcon, HelpCircleIcon } from 'lucide-react';
import { dealersData } from '../data/dealersData';
import { DealerMetrics } from '../components/dealers/DealerMetrics';
import { DealerQuotesTrend } from '../components/dealers/DealerQuotesTrend';
export function DealerDetailsPage() {
  const {
    dealerId
  } = useParams();
  const [timeRange, setTimeRange] = useState('6months');
  const [activeTab, setActiveTab] = useState('overview');
  // Find dealer data
  const dealer = dealersData.find(d => d.id === dealerId) || {
    id: 'D-12345',
    name: 'Texas International Irrigation',
    country: 'United States',
    region: 'Aisco AMERICA',
    address: '1234 Irrigation Blvd, Austin, TX 78701',
    email: 'contact@texasirrigation.com',
    phone: '+1 (512) 555-1234',
    website: 'www.texasirrigation.com',
    contactPerson: 'John Doe',
    totalQuotes: 167,
    activeQuotes: 32,
    totalRevenue: 2800000,
    customers: 45,
    conversionRate: 68,
    conversionTrend: 4.2,
    avgQuoteValue: 32500,
    targetQuoteValue: 40000,
    avgValueTrend: -2.1,
    avgResponseTime: 8,
    responseTrend: -15,
    approvedQuotes: 112,
    pendingQuotes: 38,
    rejectedQuotes: 12,
    expiredQuotes: 5,
    quotesHistory: [8, 12, 14, 9, 18, 22],
    lastActivity: '2 hours ago',
    joinedDate: 'Jan 15, 2020'
  };
  // Recent quotes data
  const recentQuotes = [{
    id: 'Q-78945',
    customer: 'Farmland Enterprises',
    product: 'Pivot Machine 8" 5/8 GALV',
    date: 'Jun 13, 2025',
    status: 'approved',
    amount: '$85,420.00'
  }, {
    id: 'Q-78932',
    customer: 'Green Valley Farms',
    product: 'Reeltown 1058 ft wiper',
    date: 'Jun 10, 2025',
    status: 'pending',
    amount: '$64,750.00'
  }, {
    id: 'Q-78921',
    customer: 'Sunset Agriculture',
    product: 'Pivot CP600',
    date: 'Jun 05, 2025',
    status: 'rejected',
    amount: '$72,180.00'
  }, {
    id: 'Q-78905',
    customer: 'Harvest Fields Inc.',
    product: 'Linear System L200',
    date: 'May 28, 2025',
    status: 'expired',
    amount: '$93,600.00'
  }];
  // Top customers data
  const topCustomers = [{
    name: 'Farmland Enterprises',
    quotes: 12,
    revenue: 420000
  }, {
    name: 'Green Valley Farms',
    quotes: 8,
    revenue: 310000
  }, {
    name: 'Sunset Agriculture',
    quotes: 7,
    revenue: 285000
  }, {
    name: 'Harvest Fields Inc.',
    quotes: 5,
    revenue: 210000
  }];
  return <div className="flex flex-col min-h-screen bg-gradient-to-br from-slate-900 to-blue-900" data-id="element-8286" data-mp="3l4ubwcl6my3g">
      {/* Header */}
      <header className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 border-b border-blue-800/30 relative z-10" data-id="element-8287" data-mp="3ge45cw10sp76">
        <div className="px-6 py-4 flex justify-between items-center" data-id="element-8288" data-mp="12xat0vspin1c">
          <div className="flex items-center" data-id="element-8289" data-mp="17u1a9mg8zooc">
            <Link to="/dealers" className="mr-3 text-blue-300 hover:text-white cursor-pointer transition-colors" data-id="element-8290" data-mp="17wx7t9o6obc9">
              <ArrowLeftIcon size={20} data-id="element-8291" data-mp="1byr2907scj3z" />
            </Link>
            <div className="p-2 mr-3 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-lg" data-id="element-8292" data-mp="1gwalkejcbm2s">
              <BuildingIcon size={20} className="text-white" data-id="element-8293" data-mp="1ltsuw619s3bb" />
            </div>
            <div data-id="element-8294" data-mp="1qsvnus3z6j2x">
              <h1 className="text-xl font-bold text-white" data-id="element-8295" data-mp="1qsdtk10viexn">{dealer.name}</h1>
              <p className="text-blue-200 text-sm hidden sm:block" data-id="element-8296" data-mp="1vk5d3rlm3kea">
                {dealer.country} - {dealer.region}
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-3" data-id="element-8297" data-mp="24l3k8irck813">
            <div className="relative hidden sm:block" data-id="element-8298" data-mp="24mmyy4xcub0r">
              <div className="relative" data-id="element-8299" data-mp="29jn5si213hsx">
                <input type="text" placeholder="Search..." className="bg-white/10 border border-blue-800/30 rounded-full pl-10 pr-4 py-2 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 w-56" data-id="element-8300" data-mp="29kogglf4u2a4" />
                <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-300" size={18} data-id="element-8301" data-mp="1qwij666om6lg" />
              </div>
            </div>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-8302" data-mp="20p7ik2oyju0f">
              <CalendarIcon size={20} data-id="element-8303" data-mp="1cz3oalxnt6m3" />
            </button>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-8304" data-mp="1800i2y5y0ucj">
              <BarChart3Icon size={20} data-id="element-8305" data-mp="1mxsvnkrxj8o3" />
            </button>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-8306" data-mp="1hxoio4q8cw2m">
              <HelpCircleIcon size={20} data-id="element-8307" data-mp="2ybeuxyri6qnc" />
            </button>
            <div className="relative" data-id="element-8308" data-mp="2ydrcwbx9h10e">
              <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-8309" data-mp="2tdmu2f8vru70">
                <BellIcon size={20} data-id="element-8310" data-mp="30vl1me7i4v7l" />
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-8311" data-mp="30ypcfufh2p78">
                  3
                </span>
              </button>
            </div>
            <div className="flex items-center bg-white/10 hover:bg-white/15 rounded-full pl-2 pr-3 py-1 cursor-pointer transition-colors" data-id="element-8312" data-mp="2vx02ki3zkhkq">
              <div className="bg-gradient-to-br from-blue-600 to-indigo-700 rounded-full w-8 h-8 flex items-center justify-center mr-2" data-id="element-8313" data-mp="3jo5h8ty6x3tg">
                <UserIcon size={16} className="text-white" data-id="element-8314" data-mp="3onruv4hxkm2s" />
              </div>
              <span className="text-white text-sm font-medium hidden sm:block" data-id="element-8315" data-mp="3auaaxilc17c8">
                Daniel Alejandro
              </span>
              <ChevronDownIcon size={16} className="text-blue-300 ml-1 hidden sm:block" data-id="element-8316" data-mp="6gkfmk3h2etn" />
            </div>
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors shadow-lg flex items-center" data-id="element-8317" data-mp="b7ke3ts8p4y9">
              <FileTextIcon size={16} className="mr-2" data-id="element-8318" data-mp="l2hj5a07ss98" />
              Nueva Cotización
            </button>
          </div>
        </div>
      </header>
      {/* Tabs */}
      <div className="px-6 py-4 border-b border-blue-800/30" data-id="element-8319" data-mp="c1jmxdw0pp17">
        <div className="flex border-b border-blue-800" data-id="element-8320" data-mp="c45s56vfrsg9">
          <button className={`px-6 py-3 font-medium transition-colors ${activeTab === 'overview' ? 'text-white border-b-2 border-white' : 'text-blue-300 hover:text-white'}`} onClick={() => setActiveTab('overview')} data-id="element-8321" data-mp="72ghvtg1fit8">
            Overview
          </button>
          <button className={`px-6 py-3 font-medium transition-colors ${activeTab === 'quotes' ? 'text-white border-b-2 border-white' : 'text-blue-300 hover:text-white'}`} onClick={() => setActiveTab('quotes')} data-id="element-8322" data-mp="3pgzgo266ggr2">
            Quotes
          </button>
          <button className={`px-6 py-3 font-medium transition-colors ${activeTab === 'customers' ? 'text-white border-b-2 border-white' : 'text-blue-300 hover:text-white'}`} onClick={() => setActiveTab('customers')} data-id="element-8323" data-mp="3fijr43mstfjo">
            Customers
          </button>
          <button className={`px-6 py-3 font-medium transition-colors ${activeTab === 'settings' ? 'text-white border-b-2 border-white' : 'text-blue-300 hover:text-white'}`} onClick={() => setActiveTab('settings')} data-id="element-8324" data-mp="35eleiquefcxa">
            Settings
          </button>
        </div>
      </div>
      {/* Main content - using flex-1 to ensure it takes remaining space */}
      <div className="flex-1 p-6 overflow-auto" data-id="element-8325" data-mp="2hnfq3nae7cbd">
        {activeTab === 'overview' && <div className="space-y-6" data-id="element-8326" data-mp="2mp5152xm7pzg">
            {/* Top cards */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-8327" data-mp="2rngazdnwu0ho">
              <MetricCard title="Total Quotes" value={dealer.totalQuotes} icon={<FileTextIcon size={20} className="text-blue-500" data-id="element-8329" data-mp="2wfzs2klt3dr8" />} color="bg-gradient-to-br from-blue-600/10 to-indigo-600/10 border-blue-500/20" textColor="text-blue-500" subtitle={`${dealer.activeQuotes} active quotes`} data-id="element-8328" data-mp="2weg74gp7gej4" />
              <MetricCard title="Total Revenue" value={`$${(dealer.totalRevenue / 1000000).toFixed(1)}M`} icon={<DollarSignIcon size={20} className="text-green-500" data-id="element-8331" data-mp="3i6f6gsfbrwuv" />} color="bg-gradient-to-br from-green-600/10 to-emerald-600/10 border-green-500/20" textColor="text-green-500" subtitle={`${dealer.customers} customers`} data-id="element-8330" data-mp="23vsttngga3sl" />
              <MetricCard title="Conversion Rate" value={`${dealer.conversionRate}%`} icon={<TrendingUpIcon size={20} className="text-purple-500" data-id="element-8333" data-mp="3n61iwznbx92m" />} color="bg-gradient-to-br from-purple-600/10 to-pink-600/10 border-purple-500/20" textColor="text-purple-500" subtitle={`+${dealer.conversionTrend}% from last period`} trend={dealer.conversionTrend > 0 ? 'up' : 'down'} data-id="element-8332" data-mp="3n3ymnxvl2jpg" />
              <MetricCard title="Avg. Response Time" value={`${dealer.avgResponseTime}h`} icon={<ClockIcon size={20} className="text-amber-500" data-id="element-8335" data-mp="9pkdc4obxqtz" />} color="bg-gradient-to-br from-amber-600/10 to-orange-600/10 border-amber-500/20" textColor="text-amber-500" subtitle={`${Math.abs(dealer.responseTrend)}% from last period`} trend={dealer.responseTrend < 0 ? 'up' : 'down'} data-id="element-8334" data-mp="eppxz0w6md2k" />
            </div>
            {/* Time range selector */}
            <div className="flex justify-end" data-id="element-8336" data-mp="17avdjka6rt3r">
              <div className="inline-flex items-center rounded-lg border border-blue-800 overflow-hidden" data-id="element-8337" data-mp="179trylvjno7s">
                <button className={`px-3 py-1.5 text-sm ${timeRange === '30days' ? 'bg-blue-700 text-white' : 'text-blue-300 hover:bg-blue-800/50'}`} onClick={() => setTimeRange('30days')} data-id="element-8338" data-mp="tac4qaxwcj0j">
                  30 Days
                </button>
                <button className={`px-3 py-1.5 text-sm ${timeRange === '3months' ? 'bg-blue-700 text-white' : 'text-blue-300 hover:bg-blue-800/50'}`} onClick={() => setTimeRange('3months')} data-id="element-8339" data-mp="oc0y092weomj">
                  3 Months
                </button>
                <button className={`px-3 py-1.5 text-sm ${timeRange === '6months' ? 'bg-blue-700 text-white' : 'text-blue-300 hover:bg-blue-800/50'}`} onClick={() => setTimeRange('6months')} data-id="element-8340" data-mp="fjp6skzymx5i">
                  6 Months
                </button>
                <button className={`px-3 py-1.5 text-sm ${timeRange === '1year' ? 'bg-blue-700 text-white' : 'text-blue-300 hover:bg-blue-800/50'}`} onClick={() => setTimeRange('1year')} data-id="element-8341" data-mp="28611w6z20cr3">
                  1 Year
                </button>
              </div>
            </div>
            {/* Dealer info and metrics */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-8342" data-mp="2364zud9x2ve6">
              {/* Dealer info */}
              <div className="bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 overflow-hidden" data-id="element-8343" data-mp="2qvz7mgfdptrk">
                <div className="p-5 border-b border-white/10" data-id="element-8344" data-mp="2vuajsxt5cgcy">
                  <h3 className="font-medium text-white flex items-center" data-id="element-8345" data-mp="2h6pgp3w9uh51">
                    <UserIcon size={16} className="mr-2 text-blue-400" data-id="element-8346" data-mp="2h4cycpmlq4rg" />
                    Dealer Information
                  </h3>
                </div>
                <div className="p-5" data-id="element-8347" data-mp="39u22hbulykxa">
                  <div className="space-y-4" data-id="element-8348" data-mp="39t0haejvoi1u">
                    <div data-id="element-8349" data-mp="3em3b8nskhtik">
                      <div className="text-sm text-blue-300" data-id="element-8350" data-mp="3enefeopxd3a7">Address</div>
                      <div className="text-white" data-id="element-8351" data-mp="1362s8oh8xjur">{dealer.address}</div>
                    </div>
                    <div data-id="element-8352" data-mp="y8jgpwbxnl6i">
                      <div className="text-sm text-blue-300" data-id="element-8353" data-mp="y78dbxmegffx">
                        Contact Person
                      </div>
                      <div className="text-white" data-id="element-8354" data-mp="1cygxvsbg3am7">{dealer.contactPerson}</div>
                    </div>
                    <div data-id="element-8355" data-mp="17zxb5pp11uss">
                      <div className="text-sm text-blue-300" data-id="element-8356" data-mp="k7gqd7dwnops">Email</div>
                      <div className="text-white" data-id="element-8357" data-mp="k9tgw8xqb7eg">{dealer.email}</div>
                    </div>
                    <div data-id="element-8358" data-mp="fb8h2ame2pqj">
                      <div className="text-sm text-blue-300" data-id="element-8359" data-mp="t96i6ebp8po3">Phone</div>
                      <div className="text-white" data-id="element-8360" data-mp="t6bywq4f9aw9">{dealer.phone}</div>
                    </div>
                    <div data-id="element-8361" data-mp="p9626p8yc6ex">
                      <div className="text-sm text-blue-300" data-id="element-8362" data-mp="24nk3bbf2ir0f">Website</div>
                      <div className="text-white flex items-center" data-id="element-8363" data-mp="24pofegn4ewbs">
                        {dealer.website}
                        <ExternalLinkIcon size={14} className="ml-1 text-blue-400" data-id="element-8364" data-mp="xbb7hl58mu3c" />
                      </div>
                    </div>
                    <div className="flex justify-between pt-2" data-id="element-8365" data-mp="129cs4aibb1gx">
                      <div data-id="element-8366" data-mp="179ikjsweos02">
                        <div className="text-sm text-blue-300" data-id="element-8367" data-mp="1798t00vpqcs9">
                          Last Activity
                        </div>
                        <div className="text-white" data-id="element-8368" data-mp="1baaxaw4hlf13">{dealer.lastActivity}</div>
                      </div>
                      <div className="text-right" data-id="element-8369" data-mp="eiqiwfwknb5c">
                        <div className="text-sm text-blue-300" data-id="element-8370" data-mp="jj4u26tgz17l">Joined</div>
                        <div className="text-white" data-id="element-8371" data-mp="nlj90fu0pgtl">{dealer.joinedDate}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Quote metrics and trends */}
              <div className="lg:col-span-2" data-id="element-8372" data-mp="3ryofijnwffc3">
                <div className="bg-gradient-to-br from-blue-900/30 to-indigo-900/30 backdrop-blur-sm rounded-xl border border-blue-500/20 overflow-hidden" data-id="element-8373" data-mp="3rxwv84zr5414">
                  <div className="p-5 border-b border-blue-800/30" data-id="element-8374" data-mp="3ogipvo0k9wtj">
                    <h3 className="font-medium text-white flex items-center" data-id="element-8375" data-mp="3ji7g1da9nmbb">
                      <BarChart3Icon size={16} className="mr-2 text-blue-400" data-id="element-8376" data-mp="3fh3wogt0f85c" />
                      Quote Performance Metrics
                    </h3>
                  </div>
                  <div className="p-5" data-id="element-8377" data-mp="3ak56g9cgvlcf">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-8378" data-mp="35jhhdt7steku">
                      {/* Quote Status Distribution */}
                      <div data-id="element-8379" data-mp="30rfyhog4kplu">
                        <h4 className="text-sm font-medium text-blue-300 mb-4" data-id="element-8380" data-mp="30q4ubnirpfu7">
                          Quote Status Distribution
                        </h4>
                        <div className="space-y-4" data-id="element-8381" data-mp="2rsktugsqbnkn">
                          <QuoteStatusBar label="Approved" value={dealer.approvedQuotes} total={dealer.totalQuotes} color="bg-green-500" data-id="element-8382" data-mp="2msgj77ei5n2c" />
                          <QuoteStatusBar label="Pending" value={dealer.pendingQuotes} total={dealer.totalQuotes} color="bg-amber-500" data-id="element-8383" data-mp="2huep7rfjg3c3" />
                          <QuoteStatusBar label="Rejected" value={dealer.rejectedQuotes} total={dealer.totalQuotes} color="bg-red-500" data-id="element-8384" data-mp="lsbo1ni0mg4d" />
                          <QuoteStatusBar label="Expired" value={dealer.expiredQuotes} total={dealer.totalQuotes} color="bg-gray-500" data-id="element-8385" data-mp="c0p6l9f33kt6" />
                        </div>
                      </div>
                      {/* Quote Value Analysis */}
                      <div data-id="element-8386" data-mp="2y63qpbat86x">
                        <h4 className="text-sm font-medium text-blue-300 mb-4" data-id="element-8387" data-mp="323plip9gdui">
                          Quote Value Analysis
                        </h4>
                        <div className="space-y-6" data-id="element-8388" data-mp="3p88zs0vtrw4t">
                          <div data-id="element-8389" data-mp="3u60s2w0dtk9j">
                            <div className="flex justify-between items-center mb-1" data-id="element-8390" data-mp="3u58wvmap5ojs">
                              <div className="text-sm text-blue-200" data-id="element-8391" data-mp="1nf2ps0yw7c2v">
                                Average Quote Value
                              </div>
                              <div className="text-sm font-medium text-white" data-id="element-8392" data-mp="1sckxxp535n9t">
                                ${dealer.avgQuoteValue.toLocaleString()}
                              </div>
                            </div>
                            <div className="w-full bg-blue-900/50 rounded-full h-2.5" data-id="element-8393" data-mp="3mmj3v5c7066n">
                              <div className="bg-blue-500 h-2.5 rounded-full" style={{
                            width: `${Math.min(dealer.avgQuoteValue / dealer.targetQuoteValue * 100, 100)}%`
                          }} data-id="element-8394" data-mp="3mocdmti3r6iv"></div>
                            </div>
                            <div className="flex justify-between text-xs mt-1" data-id="element-8395" data-mp="3qnl4nqlrcqaq">
                              <span className="text-blue-300" data-id="element-8396" data-mp="9ey4z38uzvaj">$0</span>
                              <span className="text-blue-300" data-id="element-8397" data-mp="4h643jq8kyu7">
                                Target: $
                                {dealer.targetQuoteValue.toLocaleString()}
                              </span>
                            </div>
                          </div>
                          <div data-id="element-8398" data-mp="26am6tezlm45j">
                            <div className="flex justify-between items-center mb-1" data-id="element-8399" data-mp="2vx6qmjjorvjv">
                              <div className="text-sm text-blue-200" data-id="element-8400" data-mp="2zxql1fcvkl2b">
                                Conversion Rate
                              </div>
                              <div className="text-sm font-medium text-white" data-id="element-8401" data-mp="34vs4i1e7qmeb">
                                {dealer.conversionRate}%
                              </div>
                            </div>
                            <div className="w-full bg-blue-900/50 rounded-full h-2.5" data-id="element-8402" data-mp="3ev0yuvczq317">
                              <div className="bg-purple-500 h-2.5 rounded-full" style={{
                            width: `${dealer.conversionRate}%`
                          }} data-id="element-8403" data-mp="3ivbdeweum1ro"></div>
                            </div>
                            <div className="flex justify-between text-xs mt-1" data-id="element-8404" data-mp="3sos9y86dduz1">
                              <span className="text-blue-300" data-id="element-8405" data-mp="1i7kutzvkx4n">0%</span>
                              <span className="text-blue-300" data-id="element-8406" data-mp="6givh6xzvbnx">100%</span>
                            </div>
                          </div>
                          <div className="pt-4" data-id="element-8407" data-mp="1qvf9jjjfyeeh">
                            <h5 className="text-sm font-medium text-blue-300 mb-2" data-id="element-8408" data-mp="1ly5nmdv9gkve">
                              Performance Indicators
                            </h5>
                            <div className="grid grid-cols-2 gap-3" data-id="element-8409" data-mp="1c0934vgfodkm">
                              <div className="bg-blue-900/30 p-3 rounded-lg" data-id="element-8410" data-mp="1c22bcf6p35uq">
                                <div className="text-xs text-blue-300" data-id="element-8411" data-mp="29mokzycrvd8p">
                                  Response Time
                                </div>
                                <div className="text-lg font-medium text-white" data-id="element-8412" data-mp="1zxww5z30d920">
                                  {dealer.avgResponseTime}h
                                </div>
                                <div className="text-xs text-green-400 flex items-center" data-id="element-8413" data-mp="1ux973iycb2af">
                                  <TrendingUpIcon size={12} className="mr-1" data-id="element-8414" data-mp="2sgkej6qme9ze" />
                                  15% faster
                                </div>
                              </div>
                              <div className="bg-blue-900/30 p-3 rounded-lg" data-id="element-8415" data-mp="1vy3bfphbunb4">
                                <div className="text-xs text-blue-300" data-id="element-8416" data-mp="20shco8io7onp">
                                  Quotes per Month
                                </div>
                                <div className="text-lg font-medium text-white" data-id="element-8417" data-mp="1ry30ietfsu8t">
                                  {Math.round(dealer.totalQuotes / 6)}
                                </div>
                                <div className="text-xs text-green-400 flex items-center" data-id="element-8418" data-mp="2jpihntc85orn">
                                  <TrendingUpIcon size={12} className="mr-1" data-id="element-8419" data-mp="25pzkfvkybxu4" />
                                  8% increase
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Quotes trend chart */}
            <div className="bg-gradient-to-br from-blue-900/30 to-indigo-900/30 backdrop-blur-sm rounded-xl border border-blue-500/20 overflow-hidden" data-id="element-8420" data-mp="rol3ie7mlixs">
              <div className="p-5 border-b border-blue-800/30 flex justify-between items-center" data-id="element-8421" data-mp="10rm8gbkr93zv">
                <h3 className="font-medium text-white flex items-center" data-id="element-8422" data-mp="vrht4ovl2fb8">
                  <TrendingUpIcon size={16} className="mr-2 text-blue-400" data-id="element-8423" data-mp="82f06kvi101f" />
                  Quotes & Revenue Trend
                </h3>
                <div className="text-sm text-blue-300 flex items-center" data-id="element-8424" data-mp="41msvx66t57s">
                  <CalendarIcon size={14} className="mr-1" data-id="element-8425" data-mp="hrylryalj7zz" />
                  {timeRange === '30days' ? 'Last 30 days' : timeRange === '3months' ? 'Last 3 months' : timeRange === '6months' ? 'Last 6 months' : timeRange === '1year' ? 'Last 12 months' : 'All time'}
                </div>
              </div>
              <div className="p-5" data-id="element-8426" data-mp="3gis0klz1j9z5">
                <div className="h-80 relative" data-id="element-8427" data-mp="3ghgtac6dzk3a">
                  {/* This would be a real chart in production */}
                  <div className="absolute inset-0 flex items-end justify-between px-2" data-id="element-8428" data-mp="2cybze78w3ame">
                    {Array.from({
                  length: timeRange === '30days' ? 6 : timeRange === '3months' ? 3 : timeRange === '6months' ? 6 : 12
                }, (_, i) => <div key={i} className="flex flex-col items-center" data-id="element-8429" data-mp="2hwnd4t2b259w">
                          <div className="relative" data-id="element-8430" data-mp="2vojxgaxqfavq">
                            {/* Revenue Bar */}
                            <div className="w-8 bg-green-500/60 rounded-t-sm" style={{
                      height: `${Math.random() * 100 + 50}px`
                    }} data-id="element-8431" data-mp="2rn8hyy8ko619"></div>
                            {/* Quote Bar */}
                            <div className="w-6 bg-blue-500 rounded-t-sm absolute top-0 left-1" style={{
                      height: `${Math.random() * 80 + 30}px`
                    }} data-id="element-8432" data-mp="30ndeueg53m16"></div>
                          </div>
                          <div className="text-xs text-blue-300 mt-2" data-id="element-8433" data-mp="16b6p8ami12pc">
                            {timeRange === '30days' ? `Day ${i * 5 + 1}` : timeRange === '3months' ? ['Jan', 'Feb', 'Mar'][i] : timeRange === '6months' ? ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'][i] : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][i]}
                          </div>
                        </div>)}
                  </div>
                </div>
                {/* Legend */}
                <div className="flex items-center justify-center space-x-6 mt-4" data-id="element-8434" data-mp="2z5odl6jpceyo">
                  <div className="flex items-center" data-id="element-8435" data-mp="346lwjlcjdd18">
                    <div className="w-3 h-3 rounded-full bg-blue-500 mr-2" data-id="element-8436" data-mp="3437xon32zlyj"></div>
                    <span className="text-sm text-blue-200" data-id="element-8437" data-mp="2paef2ssiippn">Quotes</span>
                  </div>
                  <div className="flex items-center" data-id="element-8438" data-mp="2u7mvooy0ilos">
                    <div className="w-3 h-3 rounded-full bg-green-500/60 mr-2" data-id="element-8439" data-mp="ngoxo63k2znx"></div>
                    <span className="text-sm text-blue-200" data-id="element-8440" data-mp="sgjn057onh6v">Revenue</span>
                  </div>
                </div>
              </div>
            </div>
            {/* Recent quotes and top customers */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-8441" data-mp="lz8ct02g9g1d">
              {/* Recent quotes */}
              <div className="bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 overflow-hidden" data-id="element-8442" data-mp="gzwu3liiw0h5">
                <div className="p-5 border-b border-white/10 flex justify-between items-center" data-id="element-8443" data-mp="d04s5rnmwskr">
                  <h3 className="font-medium text-white flex items-center" data-id="element-8444" data-mp="19oato5p9f4ut">
                    <FileTextIcon size={16} className="mr-2 text-blue-400" data-id="element-8445" data-mp="14pr5dyn71gza" />
                    Recent Quotes
                  </h3>
                  <button className="text-blue-300 hover:text-white text-sm flex items-center" data-id="element-8446" data-mp="zy7zi26ejkuw">
                    View all
                    <ChevronRightIcon size={14} className="ml-1" data-id="element-8447" data-mp="vvuy1pyou93x" />
                  </button>
                </div>
                <div className="divide-y divide-white/10" data-id="element-8448" data-mp="1shodbenivov4">
                  {recentQuotes.map(quote => <div key={quote.id} className="p-4 hover:bg-white/5 transition-colors" data-id="element-8449" data-mp="1nn0pzj4990i4">
                      <div className="flex justify-between" data-id="element-8450" data-mp="36dy5zotq31ug">
                        <div data-id="element-8451" data-mp="3bbzoo8n8kz5e">
                          <div className="flex items-center" data-id="element-8452" data-mp="3bb82tpjfyfsb">
                            <span className="text-white font-medium" data-id="element-8453" data-mp="3fca226dcyrua">
                              {quote.customer}
                            </span>
                            <span className="ml-2 px-2 py-0.5 bg-white/10 rounded-full text-xs text-blue-200" data-id="element-8454" data-mp="3k9a0bv3yuqau">
                              {quote.id}
                            </span>
                          </div>
                          <div className="text-blue-200 text-sm mt-1" data-id="element-8455" data-mp="2vempbt0v6bs">
                            {quote.product}
                          </div>
                        </div>
                        <div className="text-right" data-id="element-8456" data-mp="6yukwckqpeql">
                          <div className="text-white font-medium" data-id="element-8457" data-mp="bww18pqs6zyd">
                            {quote.amount}
                          </div>
                          <div className="text-blue-300 text-xs mt-1 flex items-center justify-end" data-id="element-8458" data-mp="gstj50hp0ed9">
                            <CalendarIcon size={12} className="mr-1" data-id="element-8459" data-mp="3649hf2pu8n8" />
                            {quote.date}
                          </div>
                        </div>
                      </div>
                      <div className="mt-2 flex justify-between items-center" data-id="element-8460" data-mp="d038i57htcay">
                        <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${quote.status === 'approved' ? 'bg-green-500/20 text-green-300' : quote.status === 'pending' ? 'bg-amber-500/20 text-amber-300' : quote.status === 'rejected' ? 'bg-red-500/20 text-red-300' : 'bg-gray-500/20 text-gray-300'}`} data-id="element-8461" data-mp="7zp899c4v6nh">
                          {quote.status === 'approved' ? <>
                              <CheckCircleIcon size={12} className="mr-1" data-id="element-8462" data-mp="3lcihyyi7tqe8" />
                              Approved
                            </> : quote.status === 'pending' ? <>
                              <ClockIcon size={12} className="mr-1" data-id="element-8463" data-mp="10mt6mvgq0mqa" />
                              Pending
                            </> : quote.status === 'rejected' ? <>
                              <AlertCircleIcon size={12} className="mr-1" data-id="element-8464" data-mp="1d6gpmb6h83fh" />
                              Rejected
                            </> : <>
                              <ClockIcon size={12} className="mr-1" data-id="element-8465" data-mp="z8idzdjjil3o" />
                              Expired
                            </>}
                        </span>
                        <button className="text-blue-400 hover:text-white text-sm" data-id="element-8466" data-mp="1qywl8qx1sz6d">
                          View details
                        </button>
                      </div>
                    </div>)}
                </div>
              </div>
              {/* Top customers */}
              <div className="bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 overflow-hidden" data-id="element-8467" data-mp="1m63fbzpufksp">
                <div className="p-5 border-b border-white/10 flex justify-between items-center" data-id="element-8468" data-mp="29vei1mqr7p9h">
                  <h3 className="font-medium text-white flex items-center" data-id="element-8469" data-mp="2eo7me9ib8vl1">
                    <UsersIcon size={16} className="mr-2 text-blue-400" data-id="element-8470" data-mp="2ojochfb8fne9" />
                    Top Customers
                  </h3>
                  <button className="text-blue-300 hover:text-white text-sm flex items-center" data-id="element-8471" data-mp="2kiw22iqmjcge">
                    View all
                    <ChevronRightIcon size={14} className="ml-1" data-id="element-8472" data-mp="2fkkru6wf2zxn" />
                  </button>
                </div>
                <div className="divide-y divide-white/10" data-id="element-8473" data-mp="2alrh2m8iln16">
                  {topCustomers.map((customer, index) => <div key={index} className="p-4 hover:bg-white/5 transition-colors" data-id="element-8474" data-mp="25m4ydx9x3ekz" data-mpi={index}>
                      <div className="flex justify-between items-center" data-id="element-8475" data-mp="20rr1fqflwze7">
                        <div className="flex items-center" data-id="element-8476" data-mp="1wsi64h4x4tgj">
                          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white font-medium mr-3" data-id="element-8477" data-mp="1rtfb7pink3ma">
                            {customer.name.charAt(0)}
                          </div>
                          <div data-id="element-8478" data-mp="1hwsrx55z5kmd">
                            <div className="text-white font-medium" data-id="element-8479" data-mp="17rar9flog2nn">
                              {customer.name}
                            </div>
                            <div className="text-blue-300 text-xs mt-0.5" data-id="element-8480" data-mp="1co17q41e909l">
                              {customer.quotes} quotes
                            </div>
                          </div>
                        </div>
                        <div className="text-right" data-id="element-8481" data-mp="1mlpbfjgz9i3w">
                          <div className="text-white font-medium" data-id="element-8482" data-mp="p1mb4smhiqsc">
                            ${customer.revenue.toLocaleString()}
                          </div>
                          <div className="text-blue-300 text-xs mt-0.5" data-id="element-8483" data-mp="yyqy2uo5mqa7">
                            Total revenue
                          </div>
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>}
        {/* Other tabs would be implemented here */}
        {activeTab !== 'overview' && <div className="flex items-center justify-center h-64 text-blue-300" data-id="element-8484" data-mp="1pfd47b7hfa0b">
            {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)} content is
            under development
          </div>}
      </div>
    </div>;
}
// Helper components
function MetricCard({
  title,
  value,
  icon,
  color,
  textColor,
  subtitle,
  trend
}) {
  return <div className={`rounded-xl p-5 ${color}`} data-id="element-8485" data-mp="1udoe1lxs1kij">
      <div className="flex justify-between items-start" data-id="element-8486" data-mp="28e7jqmersehj">
        <div data-id="element-8487" data-mp="28cwdmfxuqun9">
          <div className="text-sm text-blue-300" data-id="element-8488" data-mp="28ced3745pu9j">{title}</div>
          <div className={`text-2xl font-bold mt-1 ${textColor}`} data-id="element-8489" data-mp="24df6li2s1pfz">{value}</div>
        </div>
        <div className={`p-2 rounded-lg ${textColor.replace('text', 'bg')}/20`} data-id="element-8490" data-mp="2i4aaefyf5gcp">
          {icon}
        </div>
      </div>
      {subtitle && <div className="mt-2 text-xs flex items-center" data-id="element-8491" data-mp="2d5h4b8lgormk">
          {trend ? trend === 'up' ? <TrendingUpIcon size={12} className="mr-1 text-green-500" data-id="element-8492" data-mp="2s2ztgc21x6uj" /> : <TrendingUpIcon size={12} className="mr-1 text-red-500 transform rotate-180" data-id="element-8493" data-mp="2n3dhe5xylwnb" /> : null}
          <span className={trend === 'up' ? 'text-green-500' : trend === 'down' ? 'text-red-500' : 'text-blue-300'} data-id="element-8494" data-mp="36p6nqrrnxvgv">
            {subtitle}
          </span>
        </div>}
    </div>;
}
function QuoteStatusBar({
  label,
  value,
  total,
  color
}) {
  const percentage = Math.round(value / total * 100);
  return <div className="space-y-1" data-id="element-8495" data-mp="31pathk8rpiei">
      <div className="flex justify-between" data-id="element-8496" data-mp="31oivy3vm1all">
        <div className="flex items-center text-sm text-blue-200" data-id="element-8497" data-mp="2n0xueeedvjfs">
          <div className={`w-3 h-3 rounded-full ${color} mr-2`} data-id="element-8498" data-mp="2mzmrshwochq9"></div>
          {label}
        </div>
        <div className="text-sm text-white font-medium" data-id="element-8499" data-mp="2rsxohq7rvi4g">
          {value} ({percentage}%)
        </div>
      </div>
      <div className="w-full bg-blue-900/50 rounded-full h-2" data-id="element-8500" data-mp="2dy55uiwl5ltn">
        <div className={`${color} h-2 rounded-full`} style={{
        width: `${percentage}%`
      }} data-id="element-8501" data-mp="2j048troeygq2"></div>
      </div>
    </div>;
}